import React from 'react'
import t from '../../translations/i18n'
import '../../scss/politica.scss'

export default function PoliticaDePrivacidad() {
  return (
    <div className="page-content easybuy-privacy-page">
      <div className="container">
        <div className="easybuy-privacy-header text-center">
          <span className="easybuy-privacy-badge">
            <i className="la la-lock"></i>
            Política de privacidad
          </span>

          <h2>{t('politicas.tittle')}</h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="easybuy-privacy-card">
              <div className="easybuy-privacy-item">
                <div className="easybuy-privacy-icon">
                  <i className="la la-shield"></i>
                </div>

                <p>{t('politicas.p_1')}</p>
              </div>

              <div className="easybuy-privacy-item">
                <div className="easybuy-privacy-icon">
                  <i className="la la-user-secret"></i>
                </div>

                <p>{t('politicas.p_2')}</p>
              </div>

              <div className="easybuy-privacy-item">
                <div className="easybuy-privacy-icon">
                  <i className="la la-check-circle"></i>
                </div>

                <p>{t('politicas.p_3')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
